import React, { useEffect } from "react";
import { X } from "lucide-react";
import ContactForm from "./ContactForm";

const ContactModal = ({ open, onClose, defaultSubject = "", title = "" }) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = "";
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="idm-modal-overlay" onClick={onClose} data-testid="contact-modal-overlay">
      <div className="idm-modal" onClick={(e) => e.stopPropagation()} data-testid="contact-modal">
        <button className="idm-modal-close" onClick={onClose} aria-label="Close" data-testid="contact-modal-close">
          <X size={20} strokeWidth={2} />
        </button>
        {title && <h3 className="idm-modal-title">{title}</h3>}
        <ContactForm defaultSubject={defaultSubject} />
      </div>
    </div>
  );
};

export default ContactModal;
